/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Unknown_AccountInputs */



/**
* | output |
* | --- |
* | "You can't sign in with this email address. Check the address or ask your administrator for access." |
*
* @param {Login_Unknown_AccountInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const login_unknown_account = /** @type {((inputs?: Login_Unknown_AccountInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Unknown_AccountInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Met dit e-mailadres kan je niet aanmelden. Controleer het adres of vraag toegang aan je beheerder.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vous ne pouvez pas vous connecter avec cette adresse e-mail. Vérifiez l'adresse ou demandez l'accès à votre administrateur.")
	return /** @type {LocalizedString} */ ("You can't sign in with this email address. Check the address or ask your administrator for access.")
});